import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

/**
 * Get a FormControl from a FormArray given the index and control's name
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsGetFormArrayControl',
})
export class RdsGetFormArrayControlPipe implements PipeTransform {
  /**
   * Given a control's index and name, get the FormControl from a parent FormArray.
   *
   * @param index the index of the item
   * @param formArray the parent FormArray
   * @param controlName the name of the FormControl, i.e. 'name' or 'label'
   * @returns the FormControl found within the given FormArray
   */
  transform(index: number, formArray: FormArray | undefined, controlName: string): FormControl | null {
    if (!formArray || !controlName) {
      return null;
    }

    const foundControl = formArray.at(index).get(controlName);
    if (!foundControl) {
      return null;
    } else {
      return foundControl as FormControl;
    }
  }
}

@NgModule({
  declarations: [RdsGetFormArrayControlPipe],
  providers: [RdsGetFormArrayControlPipe],
  exports: [RdsGetFormArrayControlPipe],
})
export class RdsGetFormArrayControlPipeModule {}
